import {
  CButton,
  CCardBody,
  CCardHeader,
  CCol,
  CInput,
  CLabel,
  CRow,
  CSpinner,
} from "@coreui/react";
import React, { useEffect, useState } from "react";
import { apiCall } from "src/_apiConfig/apiCall";
import { useParams } from "react-router-dom";
const EditDistrict = () => {
  //const history = useHistory();
  const [loading, setloading] = useState(false);
  const [districtId, setdistrictId] = useState();
  const [circleId, setcircleId] = useState();
  const [name, setname] = useState();
  const [desc, setdesc] = useState();
  const [status, setstatus] = useState();

  let { id } = useParams();
  const getDistrictForEdit = async () => {
    setloading(true);
    const header = new Headers();
    const response = await apiCall(
      `District_Master?$filter=districtId%20eq%20${id}`,
      "GET",
      header,
      null
    );

    const jsonobj = await response.json();
    if (response.status === 200) {
      setname(jsonobj[0].name);
      setdesc(jsonobj[0].desc);
      setcircleId(jsonobj[0].circleId);
      setdistrictId(jsonobj[0].districtId);
      setstatus(jsonobj[0].status);
    }
    setloading(false);
  };

  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(() => getDistrictForEdit(), []);
  const postDisctData = async () => {
    setloading(true);
    const header = new Headers();
    header.append("Content-Type", "application/json");
    const response = await apiCall(
      "District_Master/update",
      "PUT",
      header,
      JSON.stringify({
        districtId: Number(districtId),
        circleId: Number(circleId),
        name: name,
        desc: desc,
        status: status,
      })
    );
    await response.json();
    if (response.status === 200) {
      window.location.href = "/master/districtlilst";
      //history.push("/districtlilst");
    }
    setloading(false);
  };
  return (
    <>
      <CCardHeader className="mb-5">
        <CRow xl={12} className="pt-3 ">
          <CCol xl={10}>
            <h3>Update District Union</h3>
          </CCol>
        </CRow>
      </CCardHeader>
      <CCardBody>
        <CRow className="mb-3">
          <CCol xl={2}>
            <CLabel htmlFor="formFile" className="col-sm-12 col-form-label">
              Name:
            </CLabel>
          </CCol>
          <CCol xl={2}>
            <CInput
              type="text"
              placeholder=""
              value={name === null ? " " : name}
              onChange={(e) => setname(e.target.value)}
            />
          </CCol>
        </CRow>
        <CRow className="mb-3">
          <CCol xl={2}>
            <CLabel htmlFor="formFile" className="col-sm-12 col-form-label">
              Description:
            </CLabel>
          </CCol>
          <CCol xl={2}>
            <CInput
              type="text"
              placeholder=""
              value={desc === null ? " " : desc}
              onChange={(e) => setdesc(e.target.value)}
            />
          </CCol>
        </CRow>
        <CRow className="mb-3">
          <CCol xl={2}>
            <CLabel htmlFor="formFile" className="col-sm-12 col-form-label">
              Status:
            </CLabel>
          </CCol>
          <CCol xl={2}>
            <input
              type="checkbox"
              checked={status ? status : false}
              onChange={() => setstatus(!status)}
            />
          </CCol>
        </CRow>
        <CRow className="mb-3">
          <CCol xl={2}>
            {loading ? (
              <CSpinner className="spinner-grow" color="success" />
            ) : (
              <div>
                <CButton
                  className="ml-3"
                  color="success"
                  onClick={() => postDisctData()}
                >
                  Update
                </CButton>
                <CButton
                  className="ml-3"
                  color="success"
                  //to="/districtlilst"
                  onClick={() =>
                    (window.location.href = "/master/districtlilst")
                  }
                >
                  Cancel
                </CButton>
              </div>
            )}
          </CCol>
        </CRow>
      </CCardBody>
    </>
  );
};
export default EditDistrict;
